import React, { forwardRef } from 'react';
import { ButtonItem } from '@atlaskit/menu';
import type { MenuItemProps } from '@atlassian/jira-navigation-types/src/types.tsx';
import { LinkItem } from '../common/ui/link-item/index.tsx';
import { RouteLinkItem } from '../common/ui/route-link-item/index.tsx';
import { useOnClick } from './utils/on-click/main.tsx';

export const MenuItem = forwardRef<HTMLAnchorElement & HTMLButtonElement, MenuItemProps>(
	(
		{
			analytics,
			href = undefined,
			onClick,
			params,
			query,
			replace,
			target = undefined,
			to,
			type,
			...rest
		},
		ref,
	) => {
		const onClickHandler = useOnClick({ onClick, analytics });

		if (to != null && __SPA__) {
			return (
				<RouteLinkItem
					ref={ref}
					onClick={onClickHandler}
					params={params}
					query={query}
					replace={replace}
					target={target}
					to={to}
					type={type}
					{...rest}
				/>
			);
		}

		return href ? (
			// eslint-disable-next-line @atlassian/a11y/anchor-has-content -- See https://go/a11y-anchor-has-content for more details
			<LinkItem ref={ref} href={href} target={target} onClick={onClickHandler} {...rest} />
		) : (
			<ButtonItem ref={ref} onClick={onClickHandler} {...rest} />
		);
	},
);
